import dayjs from 'dayjs';

import {
  DEFAULT_PER_PAGE,
  FIRST_PAGE,
  ORDER_TYPE,
  ORDER_TYPE_MAP,
  ORDER_STATUS_TYPE_MAP,
  ORDER_CARD_TYPE_TEXT_MAP,
} from '@/utils/constants';
import Order from '@/utils/orderUtil';

export default {
  name: 'GroupBuyingList',
  props: {
    currentPage: {
      default: FIRST_PAGE,
      type: Number,
    },
    currentPerPage: {
      default: DEFAULT_PER_PAGE,
      type: Number,
    },
    dateType: {
      default: 'start',
      type: String,
    },
    hasDateRange: {
      default: false,
      type: Boolean,
    },
    orders: {
      default: () => ([]),
      type: Array,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    showTitle: {
      default: true,
      type: Boolean,
    },
    sortField: {
      default: 'start',
      type: String,
    },
    sortOrder: {
      default: 'desc',
      type: String,
    },
  },
  data() {
    return {
      columns: [
        {
          cellClass: 'px-4',
          field: 'storeName',
          headerClass: 'is-size-7 px-4 py-2',
          label: '店家名稱',
          width: 106,
        },
        {
          centered: true,
          field: 'status',
          label: '訂購狀態',
          width: 48,
        },
        {
          cellClass: 'px-4',
          field: 'orderTags',
          headerClass: 'is-size-7 px-4 py-2',
          isTag: true,
          label: '自訂標籤',
          width: 146,
        },
        {
          cellClass: 'px-4',
          field: 'orderCount',
          headerClass: 'is-size-7 px-4 py-2',
          label: '訂單數',
          numeric: true,
          width: 106,
        },
        {
          cellClass: 'px-4',
          field: 'receivingCount',
          headerClass: 'is-size-7 px-4 py-2',
          label: '已領/未領',
          numeric: true,
          width: 106,
        },
        {
          cellClass: 'px-4',
          field: 'total',
          headerClass: 'is-size-7 px-4 py-2',
          label: '訂購總金額',
          numeric: true,
          width: 106,
        },
        {
          cellClass: 'px-4',
          field: 'unpaid',
          headerClass: 'is-size-7 px-4 py-2',
          label: '未收款項',
          numeric: true,
          width: 106,
        },
        {
          cellClass: 'px-4',
          field: 'subsidyTotal',
          headerClass: 'is-size-7 px-4 py-2',
          label: '補助總金額',
          numeric: true,
          width: 106,
        },
        {
          cellClass: 'px-4',
          field: 'outOfSubsidy',
          headerClass: 'is-size-7 px-4 py-2',
          label: '總自付額',
          numeric: true,
          width: 106,
        },
      ],
    };
  },
  methods: {
    columnThAttrs() {
      return {
        class: 'text-xs',
      };
    },
    formatTime(time, format = 'YYYY/MM/DD') {
      return dayjs(time).format(format);
    },
    getStatusDescription(groupBuying) {
      const { type, status } = groupBuying;

      if (type === ORDER_TYPE.NORMAL) {
        const index = ORDER_STATUS_TYPE_MAP[status];
        return ORDER_CARD_TYPE_TEXT_MAP[index];
      }
      const index = ORDER_TYPE_MAP[type];
      return ORDER_CARD_TYPE_TEXT_MAP[index];
    },
    toDetail(id) {
      window.open(`/statistics/group_buyings/${id}`, '_blank');
    },
    groupBuyingStatusColor(order) {
      const orderClass = new Order(order);
      const textColor = {
        cancelled: 'text-gray-500',
        ongoing: 'text-blue-500',
        scheduled: 'text-seaweed-green-500',
      };
      return textColor[orderClass.cardType] || '';
    },
    getCancelledColor(order) {
      if (this.isCancelledOrder(order)) {
        return 'text-gray-500';
      }
      return 'text-black';
    },
    getTimeByType(order = {}) {
      const { receiveStart = '', startTime = '' } = order || {};
      const time = this.dateType === 'start' ? startTime : receiveStart;
      return time ? this.formatTime(time) : '';
    },
    getUnreceivedColor(order) {
      const { unreceived = 0 } = order || {};
      if (this.isCancelledOrder(order)) {
        return 'text-gray-500';
      }
      return +unreceived ? 'text-red-500' : 'text-black';
    },
    isCancelledOrder(order) {
      const orderClass = new Order(order);
      const { isCancelled = false } = orderClass || {};
      return isCancelled;
    },
    onSort(field, order) {
      this.$emit('sort', field, order);
    },
  },
};
